<template>
  <b-tab
    v-if="componentName"
    :title="methodName"
  >
    <no-ssr-loader>
      <component
        :is="componentName"
        @selected-card="selectedCard"
        @error="(err) => $emit(err)"
      />
    </no-ssr-loader>
  </b-tab>
</template>

<script>
import CardDisplayStripeConnectAddCard from './CardDisplayStripeConnectAddCard.vue'
import CardDisplayIntegrapayAddCard from './CardDisplayIntegrapayAddCard.vue'
import CardDisplaySquarePaymetnsAddCard from './CardDisplaySquarePaymentsAddCard.vue'
import { mapState } from 'vuex'

export default {
  name: 'stored-card-entry-wrapper',
  props: {
    method: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('somnambulistui', ['payer']),
    userid: function() {
      return this.$store.getters['user/userid']
    },
    methodName: function() {
      return this.method.name
    },
    componentName: function() {
      switch (this.method.methodName) {
      case 'integrapay':
        return CardDisplayIntegrapayAddCard
      case 'stripe_connect_payments':
        return CardDisplayStripeConnectAddCard
      case 'square_payments':
        return CardDisplaySquarePaymetnsAddCard
      }
      return null
    }
  },
  methods: {
    selectedCard: function(val) {
      this.$emit('selected-card', val)
    }
  }

}
</script>

<style>

</style>
